/** Animated circular confidence gauge (0–100%). */

import React from "react";

interface ConfidenceGaugeProps {
  value: number; // 0–100
  size?: number;
  label?: string;
}

export default function ConfidenceGauge({
  value,
  size = 64,
  label,
}: ConfidenceGaugeProps): React.ReactElement {
  const clamped = Math.max(0, Math.min(100, value));
  const radius = (size - 8) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - clamped / 100);

  const color =
    clamped >= 70
      ? "#2FD3A6"
      : clamped >= 40
        ? "#F2B25C"
        : "#EF6E6E";

  return (
    <div className="relative inline-flex flex-col items-center" style={{ width: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.06)"
          strokeWidth={4}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={4}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={{
            transition: "stroke-dashoffset 1s cubic-bezier(0.22, 1, 0.36, 1)",
            filter: `drop-shadow(0 0 4px ${color}66)`,
          }}
        />
      </svg>
      <span
        className="absolute font-mono text-sm font-semibold text-mist-100"
        style={{ top: size / 2 - 10 }}
      >
        {clamped.toFixed(0)}%
      </span>
      {label && (
        <span className="mt-0.5 text-[10px] uppercase tracking-wide text-mist-400">{label}</span>
      )}
    </div>
  );
}
